import ValidationHelper from "newApp/utilities/ValidationHelper";
import { contains } from "newApp/utilities/StringsHelper";
import { User } from "@p1s/p1s-common-react/entities";

class UsersUtility {
    static filterByActivity(users) {
        return users.filter(user => user.isActive);
    }

    static filterUsersByProducts(users, productNames) {
        if (!productNames || productNames.length == 0)
            return users;

        return users.filter(user => UsersUtility.filterUserByProducts(user, productNames));
    }

    static filterUserByProducts(user, productNames) {
        var products = productNames.filter(productName => {
            var pr = user.userProducts.find(p => p.productName === productName);
            return pr;
        });
        return products.length > 0;
    }

    static filterByNameOrEmail(users, value) {
        if (ValidationHelper.isNullOrEmpty(value))
            return users;

        const val = value.toUpperCase();

        return users.filter(user => {
            if (user == null) {
                return false;
            }
            return contains(user.firstName + " " + user.lastName.toUpperCase(), val)
                || contains(user.lastName + " " + user.firstName, val)
                || (!ValidationHelper.isNullOrEmpty(user.email) && contains(user.email, val));
        });
    }

    static filterByIsUserLinkedToVU(users) {
        return users.filter(user => !user.isLinkedToVirtualUser);
    }

    static getCurrentUser() {
        if (window.virtualUser)
            return new User(window.virtualUser);

        return new User(window.user);
    }
}

export default UsersUtility;
